(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-FAQ"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Select all elements with the class 'faq-question'
  const faqQuestions = document.querySelectorAll('.faq-question');

  // Loop through each element
  faqQuestions.forEach(question => {
    // Add a click event listener to each question
    question.addEventListener('click', function() {
      // Toggle the 'active' class on the clicked question
      this.classList.toggle('active');
      
      // Optionally, hide other open answers (if only one should be open at a time)
      faqQuestions.forEach(otherQuestion => {
        if (otherQuestion !== this) {
          otherQuestion.classList.remove('active');
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
